
import { MessageCircle, Users, Zap } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { useUnreadMessagesContext } from "@/contexts/UnreadMessagesContext";
import { useLanguage } from "@/hooks/useLanguage";
import CustomCompass from "@/components/icons/CustomCompass";

const BottomNav = () => {
  const location = useLocation();
  const { unreadCount } = useUnreadMessagesContext();
  const { t, isRTL } = useLanguage();

  console.log('🚀 BottomNav rendering on path:', location.pathname);
  console.log('📨 BottomNav unreadCount:', unreadCount);

  const navItems = [
    { icon: CustomCompass, label: t("discovery"), path: "/discovery" },
    { icon: Users, label: t("matching"), path: "/matches" },
    { icon: MessageCircle, label: t("messages"), path: "/messages", badge: unreadCount },
    { icon: Zap, label: t("buzzz"), path: "/buzzz" },
  ];

  return (
    <nav 
      className={`fixed bottom-0 left-0 right-0 bg-carbon/95 backdrop-blur-sm border-t border-ice-white/10 px-4 py-2 z-[99999] ${isRTL ? 'rtl' : 'ltr'}`}
      style={{ 
        position: 'fixed',
        bottom: '0',
        left: '0',
        right: '0',
        zIndex: 99999
      }}
    >
      <div className="flex justify-around max-w-md mx-auto">
        {navItems.map(({ icon: Icon, label, path, badge }) => {
          const isActive = location.pathname === path;
          return (
            <Link
              key={path}
              to={path}
              className={cn(
                "flex items-center justify-center p-2 rounded-lg transition-all duration-300 relative",
                isActive
                  ? "text-neon-red"
                  : "text-ice-white/60 hover:text-ice-white"
              )}
            >
              <div className="relative">
                <Icon className={cn(
                  "w-6 h-6 transition-all duration-300",
                  isActive ? "scale-110 glow-neon-red" : "hover:scale-105"
                )} />
                {badge !== undefined && badge > 0 && (
                  <Badge 
                    variant="destructive" 
                    className="absolute -top-2 -right-2 h-5 min-w-5 text-xs px-1 flex items-center justify-center bg-neon-red text-ice-white border-0 glow-neon-red font-manrope"
                  >
                    {badge > 99 ? '99+' : badge}
                  </Badge>
                )}
              </div>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
